import { Component } from 'react'
import { HiArrowPath } from 'react-icons/hi2'
import { Alert, Beacon, Button, EmptyState } from '../ui'

/**
 * ErrorBoundary — render paytidagi xatolarda oq ekran o'rniga
 * foydalanuvchiga tushunarli fallback UI ko'rsatadi.
 *
 * Ekran uchta savolga javob beradi: nima bo'ldi, ma'lumotga nima bo'ldi,
 * endi nima qilish kerak. Texnik tafsilot pastda alohida blokda —
 * operator uni administratorga aynan ko'chirib bera oladi.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, message: '' }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || '' }
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary] Render xatosi:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="ui-center" style={{ minHeight: '100vh', padding: 24 }}>
          <div style={{ width: '100%', maxWidth: 480, display: 'flex', flexDirection: 'column', gap: 16 }}>
            <EmptyState
              icon={Beacon}
              title="Sahifa chizilmadi"
              text="Interfeys shu bo'limni ko'rsatishda to'xtadi. Serverdagi ma'lumotlar joyida — sahifani yangilasangiz ish davom etadi. Xato takrorlansa, quyidagi matnni administratorga yuboring."
              action={
                <Button variant="primary" icon={HiArrowPath} onClick={() => window.location.reload()}>
                  Sahifani yangilash
                </Button>
              }
            />
            {this.state.message && (
              <Alert tone="danger" title="Texnik tafsilot">
                <span className="ui-mono" style={{ fontSize: 'var(--ui-fs-xs)' }}>{this.state.message}</span>
              </Alert>
            )}
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
